import React, { Component } from "react";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import CardLessDataTable from "../../../neetjee_guru/components/datatables/CardLessDataTable";
import * as Cookies from "es-cookie";
const FETCH_PREVIOUSDATA = gql`
  query (
    $examType: Int
    $subjects: String
    $years: String
    $id: Int!
    $student_user_exam_id: Int
  ) {
    getPreviousPaperAnalysis(
      examType: $examType
      subjects: $subjects
      years: $years
      student_user_id: $id
      student_user_exam_id: $student_user_exam_id
    ) {
      subjects_weightage {
        id
        complexity {
          id

          qsCount
          year {
            id
            year
            count
          }
        }
      }
      complexityWeightage {
        id
        qsCount
        year {
          id
          year
          count
        }
      }
    }
  }
`;
class ComplexityInner extends Component {
  subjectQuestionTheoryColumns(data, type) {
    let newArray = [];
    if (data.length > 0) {
      if (type == "complexity") {
        const newObj = {
          dataField: "complexity",
          text: "Complexity",
          sort: true,
          headerAlign: "left",
          sortFunc: (a, b, order, dataField) => {
            let aslice = a.split(" ");
            let bslice = b.split(" ");

            let finala = 0;
            let finalb = 0;

            if (aslice.length > 1) finala = parseInt(aslice[0]);

            if (bslice.length > 1) finalb = parseInt(bslice[0]);

            if (order === "asc") {
              return finalb - finala;
            }

            return finala - finalb; // desc
          },

          //footer: "Total"
        };
        newArray.push(newObj);
      }

      const qs = {
        dataField: "qsCount",
        text: "Questions",
        sort: true,
        headerAlign: "left",
        formatter: this.props.actionsFormatter3,
        sortFunc: (a, b, order, dataField) => {
          let aslice = a.split(" ");
          let bslice = b.split(" ");

          let finala = 0;
          let finalb = 0;

          if (aslice.length > 1) finala = parseInt(aslice[0]);

          if (bslice.length > 1) finalb = parseInt(bslice[0]);

          if (order === "asc") {
            return finala - finalb;
          }
          return finalb - finala; // desc
        },
      };
      newArray.push(qs);

      data[0].year.map((item) => {
        if (item != undefined) {
          let first_word = item.year.split("-")[0];
          const newObj = {
            dataField: item.year,
            text: item.year,
            sort: true,
            headerAlign: "left",
            formatter: this.props.actionsFormatter2,
            events: {
              onClick: this.props.handleModalFunction,
            },
            sortFunc: (a, b, order, dataField) => {
              let aslice = a.split(" ");
              let bslice = b.split(" ");

              let finala = 0;
              let finalb = 0;

              if (aslice.length > 1) finala = parseInt(aslice[0]);

              if (bslice.length > 1) finalb = parseInt(bslice[0]);

              if (order === "asc") {
                return finala - finalb;
              }
              return finalb - finala; // desc
            },
          };

          newArray.push(newObj);
        }
      });
    }

    return newArray;
  }
  defaultSorted = [
    {
      dataField: "qsCount",
      order: "desc",
    },
  ];

  subjectQuestionTheoryData(data, type, subid) {
    let newArray = [];
    if (data.length > 0) {
      let qper = 0;
      data.map((map) => {
        qper = parseFloat(qper) + parseFloat(map.qsCount);
      });

      data.map((item) => {
        if (item != "") {
          const ftotper = (parseInt(item.qsCount) / parseInt(qper)) * 100;
          let tperval = "";
          if (isNaN(ftotper)) {
            tperval = 0;
          } else {
            tperval = ftotper.toFixed(1);
          }
          let newObj = "";
          if (type == "complexity") {
            newObj = {
              id: item.id,
              complexity: item.complexity,
              qsCount: parseInt(item.qsCount) + " " + tperval,
              type: "complexity",
              subjectid: subid,
              sortdata: parseInt(item.qsCount),
            };
          }
          item.year.map((item2) => {
            //for total percentage
            let mtotarry = [];

            data.map((dmap) => {
              let totarry = [];
              //qsCount
              //totarry.push(parseInt(dmap.qsCount));
              dmap.year.map((a) => {
                if (item2.year == a.year) {
                  totarry.push(parseInt(a.count));
                }
              });
              mtotarry.push(...totarry);
            });

            var sum = mtotarry.reduce(function (a, b) {
              return a + b;
            }, 0);

            //end total percentage

            const field2 = item2.year;

            const field2p = (parseInt(item2.count) / parseInt(sum)) * 100;
            let val = "";
            if (isNaN(field2p)) {
              val = 0;
            } else {
              val = Math.round(field2p);
            }
            const newObj1 = {
              ...newObj,
              [`${field2}`]: item2.count + " " + val,
            };
            newObj = newObj1;
          });
          newArray.push(newObj);
        }
      });
    }
    return newArray;
  }
  subjectClassFun = (item) => {
    if (item == "Botany") {
      return "single-subject botany";
    } else if (item == "Physics") {
      return "single-subject physics";
    } else if (item == "Chemistry") {
      return "single-subject chemistry";
    } else if (item == "Zoology") {
      return "single-subject zoology";
    } else if (item == "Mathematics") {
      return "single-subject botany";
    }
  };

  imageFunction(item) {
    if (item == "Botany") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="13.273"
          height="26.195"
          viewBox="0 0 13.273 36.195"
        >
          {" "}
          <path
            fill="#00b186"
            d="M20.168,128.355v1.8c-.495,0-.969-.007-1.441,0-.451.009-1.04-.091-1.033.588.007.632.568.533,1,.537.458,0,.916,0,1.441,0v2c-.831,0-1.673.006-2.514,0-.435,0-.913,0-.894.575s.506.555.932.553c.818,0,1.638,0,2.5,0v1.971c-.588,0-1.162,0-1.736,0-.416,0-.8.14-.707.593.044.221.436.484.7.524a12.179,12.179,0,0,0,1.725.025v1.967c-.86,0-1.7,0-2.543,0-.445,0-.9.053-.872.615.023.518.474.524.881.521.843-.006,1.687,0,2.52,0a5.046,5.046,0,0,1-5.292,5.138,5.1,5.1,0,0,1-4.9-5.081c-.026-3.86,0-7.722-.022-11.583,0-.5.193-.732.645-.733C13.732,128.351,16.909,128.355,20.168,128.355Z"
            transform="translate(-8.46 -109.571)"
          />{" "}
          <path
            fill="#00b186"
            d="M6.067,14.1V11.26c-.386-.069-.762-.124-1.134-.2a6.2,6.2,0,0,1-4.9-6.227c.015-.578.269-.774.806-.762a6.544,6.544,0,0,1,4.8,2.1c.11.116.215.236.36.4a19.8,19.8,0,0,1,.32-2A6.187,6.187,0,0,1,12.227,0c.89,0,1,.114.973,1.021A6.12,6.12,0,0,1,7.869,7.01c-.215.031-.427.073-.669.116v6.865c.259.015.514.04.767.041,1.166.009,2.334-.032,3.5.026a1.864,1.864,0,0,1,1.809,1.913A1.841,1.841,0,0,1,11.4,17.8q-4.772.04-9.547,0A1.805,1.805,0,0,1,0,15.953,1.841,1.841,0,0,1,1.926,14.1C3.281,14.086,4.636,14.1,6.067,14.1Z"
            transform="translate(0 0.001)"
          />{" "}
        </svg>
      );
    } else if (item == "Zoology") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26.427"
          height="22.969"
          viewBox="0 0 36.427 32.969"
        >
          <path
            fill="#8f4e02"
            d="M50.772,106.083h4.68c.094,0,.189,0,.282,0,.579.015.954.338.955.818,0,.5-.384.823-.993.811q-3.21-.063-6.42-.131-4.239-.09-8.478-.185a4.834,4.834,0,0,1-.685-.044.8.8,0,0,1-.414-1.372q1.066-1.239,2.167-2.45c.751-.826,1.549-1.611,2.274-2.459a7.431,7.431,0,0,0,1.935-4.1,23.883,23.883,0,0,0-.057-2.451,3.075,3.075,0,0,1,.125-1.054c.781-2.146,1.594-4.281,2.395-6.42.019-.049.026-.1.066-.27-.146.168-.229.256-.3.35q-1.054,1.355-2.1,2.711c-.343.441-.68.563-1.072.4s-.535-.494-.483-1.04c.166-1.741.371-3.48.466-5.225a5.175,5.175,0,0,0-2-4.385q-1.543-1.3-3.1-2.592a2.21,2.21,0,0,0-3.076-.008c-1.078.893-2.163,1.778-3.219,2.7a5.371,5.371,0,0,0-1.869,4.875c.16,1.552.3,3.106.444,4.66.052.579-.107.876-.5,1.03s-.727.015-1.093-.456c-.758-.977-1.515-1.955-2.331-2.906a2.709,2.709,0,0,0,.074.27c.805,2.152,1.623,4.3,2.406,6.46a2.049,2.049,0,0,1,.058,1.017c-.508,2.819.571,5.07,2.44,7.069,1.3,1.4,2.577,2.821,3.864,4.234a.833.833,0,0,1-.662,1.442q-5.451.114-10.9.234-2.2.047-4.4.1c-.571.012-.913-.23-.978-.686a.812.812,0,0,1,.887-.943q2.382-.051,4.764-.1a.411.411,0,0,0,.286-.083c-.728-.163-1.454-.328-2.182-.489-.617-.137-1.235-.267-1.852-.4a.832.832,0,0,1-.749-1c.1-.471.527-.709,1.11-.584,1.525.325,3.046.663,4.569.995l2.219.481c-.115-.155-.165-.237-.23-.307q-2.7-2.92-5.407-5.835a3.2,3.2,0,0,1-.55-3.868c.157-.312.316-.623.474-.936A3.575,3.575,0,0,1,28.264,92.2l.354.143c-.069-.21-.115-.371-.174-.528C27.357,88.905,26.263,86,25.185,83.09a.528.528,0,0,0-.574-.421c-.753.007-1.508-.019-2.261-.033-.588-.011-.936-.321-.932-.827s.354-.795.955-.8h1.173c-.237-.249-.415-.439-.6-.626-.206-.212-.426-.413-.623-.633a.8.8,0,0,1,.007-1.186.811.811,0,0,1,1.158.06c.4.394.771.811,1.156,1.218l.139-.072c0-.384-.006-.768,0-1.152.011-.593.322-.956.809-.954s.809.379.812.956c0,.889,0,1.777.01,2.665a.862.862,0,0,0,.135.482c1.219,1.592,2.451,3.174,3.681,4.758a2.173,2.173,0,0,0,.176.159c-.053-.605-.082-1.127-.146-1.645a7.006,7.006,0,0,1,2.146-6.353c1.191-1.107,2.46-2.136,3.743-3.137a3.769,3.769,0,0,1,4.714.049c1.22.974,2.436,1.958,3.587,3.011a6.847,6.847,0,0,1,2.255,6.034c-.066.654-.117,1.31-.176,1.965l.116.1a1.547,1.547,0,0,1,.136-.274c1.177-1.522,2.362-3.039,3.53-4.568a1.061,1.061,0,0,0,.2-.584c.023-.834.011-1.669.013-2.5a2.707,2.707,0,0,1,.015-.363.811.811,0,0,1,1.619.043c.023.436,0,.875,0,1.313l.138.079c.389-.419.768-.849,1.172-1.254a.813.813,0,0,1,1-.129.74.74,0,0,1,.359.866,1.211,1.211,0,0,1-.308.5c-.357.375-.737.729-1.2,1.176.509,0,.879,0,1.248,0,.592,0,.95.31.949.808s-.367.8-.951.815c-.781.015-1.562.017-2.341.057a.546.546,0,0,0-.408.263c-1.157,3.039-2.294,6.085-3.435,9.131a.979.979,0,0,0-.037.142,13.282,13.282,0,0,1,1.753-.282,3.323,3.323,0,0,1,3.105,1.815c.211.359.385.739.572,1.111a3.174,3.174,0,0,1-.524,3.87c-1.7,1.843-3.4,3.674-5.1,5.511a2.423,2.423,0,0,0-.458.63c.8-.171,1.594-.339,2.39-.513q2.107-.46,4.214-.923c.63-.138,1.061.051,1.189.516a.812.812,0,0,1-.678,1.044c-1.233.275-2.468.54-3.7.81-.115.025-.227.061-.342.092C50.772,105.965,50.772,106.023,50.772,106.083Zm-8.655-.4.041.152c.666,0,1.334.015,2-.011a.822.822,0,0,0,.51-.22c.565-.576,1.1-1.178,1.653-1.771q2.854-3.081,5.707-6.162a1.529,1.529,0,0,0,.3-2.081c-.168-.337-.337-.673-.515-1.005a1.866,1.866,0,0,0-2.5-.877c-.456.2-.888.448-1.341.651a.418.418,0,0,0-.282.526,7.535,7.535,0,0,1-.092,2.846,11.691,11.691,0,0,1-3.331,5.612C43.517,104.1,42.83,104.9,42.117,105.687Zm-7.344.15.053-.151c-.724-.792-1.422-1.611-2.179-2.37a11.729,11.729,0,0,1-3.264-5.425,7.69,7.69,0,0,1-.157-2.8c.027-.23.17-.511-.165-.672-.521-.248-1.026-.536-1.559-.757a1.864,1.864,0,0,0-2.3.805c-.232.409-.436.834-.647,1.254a1.515,1.515,0,0,0,.263,1.856q3.746,4.04,7.494,8.079a.492.492,0,0,0,.293.175C33.328,105.843,34.051,105.836,34.773,105.836Z"
            transform="translate(-20.263 -74.748)"
          />
          <path
            fill="#8f4e02"
            d="M256.745,131.2a10.473,10.473,0,0,1,.33-1.524,4.414,4.414,0,0,0-.867-4.483c-.049-.064-.113-.117-.161-.18-.158-.206-.2-.43.016-.609a.379.379,0,0,1,.6.1,14.659,14.659,0,0,1,1.157,1.923,4.284,4.284,0,0,1,.06,3.341,4.266,4.266,0,0,0-.142,2.5c.241,1.088.443,2.185.657,3.279.054.278.074.567-.29.64-.334.067-.438-.164-.493-.445-.252-1.292-.514-2.582-.762-3.874a5.139,5.139,0,0,1-.044-.643Z"
            transform="translate(-236.844 -120.286)"
          />
          <path
            fill="#8f4e02"
            d="M202.56,135.935c.177-.915.333-1.72.491-2.523.091-.461.179-.923.279-1.382a3.681,3.681,0,0,0-.162-2.1,5.168,5.168,0,0,1,1.047-5.233c.041-.053.087-.1.133-.151a.4.4,0,0,1,.6-.081c.222.184.167.395.009.6a9.572,9.572,0,0,0-.656.916,4.092,4.092,0,0,0-.374,3.708,4.242,4.242,0,0,1,.2,2.382q-.369,1.878-.736,3.757c-.049.247-.172.463-.452.4C202.79,136.193,202.665,136.019,202.56,135.935Z"
            transform="translate(-187.806 -120.342)"
          />
          <path
            fill="#8f4e02"
            d="M206.565,334.208c-.09.094-.2.312-.332.321a.559.559,0,0,1-.454-.261,7.811,7.811,0,0,1-.3-1.125c-.369-1.541-.732-3.084-1.1-4.624-.066-.275-.085-.531.238-.627s.464.113.531.4q.685,2.86,1.373,5.719C206.522,334.046,206.533,334.085,206.565,334.208Z"
            transform="translate(-189.434 -307.384)"
          />
          <path
            fill="#8f4e02"
            d="M268.829,328.564c-.106.437-.192.789-.277,1.141q-.569,2.37-1.137,4.739c-.063.265-.168.528-.494.465s-.374-.322-.3-.629c.374-1.526.738-3.054,1.106-4.582a9.244,9.244,0,0,1,.3-1.168.57.57,0,0,1,.448-.272C268.607,328.262,268.729,328.47,268.829,328.564Z"
            transform="translate(-246.655 -307.743)"
          />
          <path
            fill="#8f4e02"
            d="M293.634,163.368c-.132.589-.272,1.256-.435,1.916-.066.268-.23.482-.553.371s-.3-.367-.21-.631a5.011,5.011,0,0,0,.225-2.81c-.031-.137.151-.321.234-.483.17.091.447.15.489.282A10.476,10.476,0,0,1,293.634,163.368Z"
            transform="translate(-270.354 -154.69)"
          />
          <path
            fill="#8f4e02"
            d="M181.79,163.113c.086-.517.135-.889.212-1.254.053-.248.21-.422.487-.364s.347.278.287.529a4.777,4.777,0,0,0,.2,2.726,1.129,1.129,0,0,1,.043.155c.046.231.023.439-.236.524a.381.381,0,0,1-.524-.3C182.082,164.421,181.928,163.7,181.79,163.113Z"
            transform="translate(-168.717 -154.464)"
          />
        </svg>
      );
    } else if (item == "Physics") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26.996"
          height="27.02"
          viewBox="0 0 26.996 27.02"
        >
          <path
            fill="#ea9909"
            d="M23.09,6.474c.084-.345.162-.684.249-1.02a11.758,11.758,0,0,1,1.578-3.876A5.19,5.19,0,0,1,26.057.4a1.952,1.952,0,0,1,2.41.017,12.048,12.048,0,0,1,.97.864,2.28,2.28,0,0,1,2.2-.054,2.378,2.378,0,0,1,1.182,1.31,2.448,2.448,0,0,1-1.592,3.195l.175.751c.15-.04.282-.073.412-.11a13.7,13.7,0,0,1,4.348-.677A5.907,5.907,0,0,1,37.9,6.02a2.15,2.15,0,0,1,1.366,2.721,7.4,7.4,0,0,1-1.821,3.042c-.536.6-1.117,1.152-1.706,1.754.181.168.38.346.572.531a12.013,12.013,0,0,1,2.645,3.367,3.2,3.2,0,0,1,.388,1.739,2.3,2.3,0,0,1-1.868,1.985c-.039.009-.078.015-.128.024-.028.187-.046.374-.085.559a2.367,2.367,0,0,1-4.688-.511c.008-.318-.085-.442-.38-.492-.253-.042-.5-.127-.769-.2-.15.585-.278,1.149-.441,1.7a10.159,10.159,0,0,1-1.7,3.625,2.539,2.539,0,0,1-2.144,1.139,2.625,2.625,0,0,1-1.912-1.122,8.569,8.569,0,0,1-1.462-2.88c-.231-.724-.406-1.466-.607-2.2-.021-.076-.04-.152-.068-.262l-2.044.522a1.493,1.493,0,0,1-.4,1.133,1.465,1.465,0,0,1-2.491-.605c-.058-.215-.154-.277-.375-.324a6.629,6.629,0,0,1-1.539-.461,2.089,2.089,0,0,1-1-2.525,7.371,7.371,0,0,1,1.82-3.043c.536-.6,1.117-1.152,1.708-1.755-.187-.173-.393-.357-.592-.55a11.842,11.842,0,0,1-2.636-3.374,3.171,3.171,0,0,1-.366-1.8,2.076,2.076,0,0,1,1.317-1.7,5.508,5.508,0,0,1,2.657-.35,17.412,17.412,0,0,1,3.768.736A1.391,1.391,0,0,0,23.09,6.474Zm7.959,7.038h0c0-.682.008-1.365-.008-2.047a.418.418,0,0,0-.187-.3q-1.689-.951-3.4-1.871a.5.5,0,0,0-.411,0q-1.708.918-3.4,1.873a.444.444,0,0,0-.188.323q-.019,2.017,0,4.034a.411.411,0,0,0,.165.307q1.716.966,3.449,1.9a.437.437,0,0,0,.354,0q1.733-.935,3.449-1.9a.384.384,0,0,0,.165-.278C31.056,14.878,31.05,14.2,31.05,13.513Zm-7.021,6.76c.147.573.278,1.169.455,1.751a9.354,9.354,0,0,0,1.577,3.317c.025.031.051.062.077.092a1.309,1.309,0,0,0,2.221-.014,8.677,8.677,0,0,0,1-1.631,14.66,14.66,0,0,0,1.095-3.525c-1.056-.443-2.087-.877-3.121-1.3a.293.293,0,0,0-.2.019C26.121,19.4,25.106,19.823,24.028,20.273Zm-4.5-7.415c.806-.586,1.559-1.174,2.356-1.694a1.3,1.3,0,0,0,.723-1.144c.029-.847.182-1.69.286-2.568-.347-.1-.7-.2-1.057-.29a11.269,11.269,0,0,0-3.8-.452,4.418,4.418,0,0,0-1.268.325.944.944,0,0,0-.607,1.041,3.385,3.385,0,0,0,.243.981A12.155,12.155,0,0,0,19.527,12.858Zm15.458-.019a13.841,13.841,0,0,0,2.742-3.08,5.614,5.614,0,0,0,.58-1.311,1.147,1.147,0,0,0-.791-1.529,2.862,2.862,0,0,0-1.022-.209,22.666,22.666,0,0,0-2.632.194c-.766.112-1.513.348-2.24.522.117,1.086.224,2.111.342,3.135a.388.388,0,0,0,.147.239C33.056,11.478,34.007,12.147,34.985,12.839ZM19.463,14.15c-.69.748-1.419,1.493-2.1,2.283A5.17,5.17,0,0,0,16.2,18.544a1.167,1.167,0,0,0,.823,1.564,6.3,6.3,0,0,0,1.145.217.381.381,0,0,0,.276-.117,1.449,1.449,0,0,1,2.051-.188.35.35,0,0,0,.231.093c.729-.165,1.455-.344,2.157-.513-.115-1.085-.22-2.11-.338-3.134a.39.39,0,0,0-.149-.239C21.447,15.549,20.5,14.88,19.463,14.15Zm11-7.372c-.059-.254-.133-.5-.172-.759A.331.331,0,0,0,30,5.709a2.4,2.4,0,0,1-1.543-3.352c.21-.444.215-.449-.128-.8a2.852,2.852,0,0,0-.439-.364.99.99,0,0,0-1.209-.025,3.743,3.743,0,0,0-.83.812A11.422,11.422,0,0,0,24.238,5.9c-.077.3-.134.6-.2.879a21.639,21.639,0,0,1,2.236.908,1.9,1.9,0,0,0,1.977-.005A22.5,22.5,0,0,1,30.461,6.778Zm1.151,12.794c.389.107.781.225,1.178.318a.308.308,0,0,0,.242-.105,2.35,2.35,0,0,1,4,.281.313.313,0,0,0,.251.127,1.241,1.241,0,0,0,1.062-1.313,3.151,3.151,0,0,0-.291-1.03,12.6,12.6,0,0,0-3.093-3.7l-.254.188c-.694.512-1.366,1.059-2.09,1.524a1.3,1.3,0,0,0-.717,1.149C31.864,17.861,31.715,18.7,31.612,19.572Zm3.337,3.1a1.47,1.47,0,0,0,1.4-1.473,1.454,1.454,0,0,0-1.42-1.421,1.471,1.471,0,0,0-1.405,1.473A1.456,1.456,0,0,0,34.949,22.673ZM32.012,3.39a1.413,1.413,0,1,0-2.825-.066,1.413,1.413,0,0,0,2.825.066Zm.065,11.69,2.14-1.575-2.14-1.566Zm-9.651.009V11.94l-2.137,1.58Zm1.416-7.336c-.1.792-.194,1.519-.294,2.3L26.1,8.647Zm7.113,9.216L28.4,18.38l2.258.885C30.762,18.474,30.855,17.751,30.955,16.969ZM28.4,8.646l2.551,1.4c-.1-.793-.2-1.523-.3-2.293ZM23.843,19.267l2.251-.894-2.547-1.4C23.648,17.755,23.743,18.483,23.843,19.267Zm-4.269,2.439a.536.536,0,0,0,.5-.539.51.51,0,0,0-1.019.02A.539.539,0,0,0,19.575,21.706Z"
            transform="translate(-14.235 0.009)"
          />
          <path
            fill="#ea9909"
            d="M81.749,20.166A1.928,1.928,0,1,1,83.665,18.2,1.914,1.914,0,0,1,81.749,20.166Zm0-.963a.965.965,0,1,0-.975-.947A.988.988,0,0,0,81.749,19.2Z"
            transform="translate(-74.99 -15.324)"
          />
          <path
            fill="#ea9909"
            d="M2.89,201.433a1.431,1.431,0,0,1-1.484,1.437,1.446,1.446,0,0,1,.078-2.891A1.429,1.429,0,0,1,2.89,201.433Zm-.964-.008a.508.508,0,0,0-.481-.482.481.481,0,1,0,0,.962A.5.5,0,0,0,1.926,201.426Z"
            transform="translate(0 -187.903)"
          />
          <path
            fill="#ea9909"
            d="M400.662,202.88a1.445,1.445,0,1,1,1.447-1.473A1.429,1.429,0,0,1,400.662,202.88Zm.484-1.43a.51.51,0,0,0-.467-.5.5.5,0,0,0-.5.466.51.51,0,0,0,.467.5A.5.5,0,0,0,401.146,201.449Z"
            transform="translate(-375.113 -187.913)"
          />
          <path
            fill="#ea9909"
            d="M180.469,186.448a2.41,2.41,0,1,1-2.383-2.429A2.393,2.393,0,0,1,180.469,186.448Zm-.963-.016a1.447,1.447,0,1,0-1.473,1.443A1.473,1.473,0,0,0,179.506,186.433Z"
            transform="translate(-165.043 -172.907)"
          />
        </svg>
      );
    } else if (item == "Chemistry") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19.112"
          height="23.193"
          viewBox="0 0 19.112 23.193"
        >
          <path
            fill="#2a90e0"
            d="M9.559,23.18c-2.259,0-4.518-.009-6.776,0A2.524,2.524,0,0,1,.294,21.932,2.478,2.478,0,0,1,.6,19.176q2.884-4.279,5.712-8.6a1.939,1.939,0,0,0,.3-.984q.036-3.757,0-7.514c0-.263-.231-.518-.324-.788S6.039.722,6.114.507A.873.873,0,0,1,6.743.019q2.817-.057,5.635,0a.856.856,0,0,1,.617.494c.074.219-.086.528-.177.787s-.321.517-.324.776q-.038,3.757,0,7.514a1.919,1.919,0,0,0,.3.984q2.87,4.37,5.789,8.707a2.419,2.419,0,0,1,.269,2.587,2.378,2.378,0,0,1-2.315,1.31Q13.047,23.183,9.559,23.18ZM7.409.876c-.034.521-.089,1-.09,1.484C7.31,4.8,7.331,7.236,7.3,9.671a2.316,2.316,0,0,1-.359,1.171q-2.882,4.4-5.822,8.762a1.805,1.805,0,0,0-.244,2,1.832,1.832,0,0,0,1.815.9q6.875-.008,13.751,0a1.8,1.8,0,0,0,1.807-.909,1.856,1.856,0,0,0-.259-2.006q-2.937-4.364-5.824-8.761a2.155,2.155,0,0,1-.329-1.108c-.027-2.939-.016-5.88-.016-8.87l.448-.085c0-.024-.007-.049-.011-.073H6.833c0,.024-.007.049-.009.073Z"
            transform="translate(0 0.009)"
          />
          <path
            fill="#2a90e0"
            d="M19.658,113.337a1.235,1.235,0,0,1,.953-1.352,1.491,1.491,0,0,1,1.795.671l1.463-.75c.992,1.5,2,2.928,2.893,4.416a1.5,1.5,0,0,1-1.312,2.259q-6.677.03-13.353,0a1.509,1.509,0,0,1-1.281-2.284c1-1.612,2.083-3.17,3.168-4.8A26.011,26.011,0,0,0,16.4,112.5c1.074.333,2.183.548,3.277.815a1.218,1.218,0,0,0,.791,1.387,1.444,1.444,0,0,0,1.982-1.762C21.477,113.08,20.567,113.209,19.658,113.337Zm-2.523,2.982a.963.963,0,0,0,.961-.982.985.985,0,0,0-.966-.988.985.985,0,1,0,.005,1.97Z"
            transform="translate(-9.166 -96.445)"
          />
          <path
            fill="#2a90e0"
            d="M61.41,78.905c.308,1.075.008,1.812-.808,2.052a1.363,1.363,0,0,1-1.726-.967c-.228-.81.278-1.469,1.383-1.78-.022-.538.166-1.03.746-1.067a1.2,1.2,0,0,1,.918.475C62.271,78.185,61.9,78.615,61.41,78.905Z"
            transform="translate(-50.885 -66.732)"
          />
          <path
            fill="#2a90e0"
            d="M67.549,45.4c-.263.174-.555.514-.784.478a.928.928,0,0,1-.625-.664c0-.225.4-.6.649-.629.232-.027.509.318.765.5C67.553,45.186,67.55,45.292,67.549,45.4Z"
            transform="translate(-57.216 -38.563)"
          />
          <path
            fill="#2a90e0"
            d="M67.98,27.36c.237.3.507.5.476.625-.049.194-.306.337-.474.5-.15-.158-.4-.3-.42-.476S67.772,27.664,67.98,27.36Z"
            transform="translate(-58.446 -23.667)"
          />
        </svg>
      );
    } else if (item == "Mathematics") {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19.112"
          height="23.193"
          viewBox="0 0 24 24"
        >
          <path
            fill="#333"
            d="m21.25 24h-18.5c-1.517 0-2.75-1.233-2.75-2.75v-18.5c0-1.517 1.233-2.75 2.75-2.75h18.5c1.517 0 2.75 1.233 2.75 2.75v18.5c0 1.517-1.233 2.75-2.75 2.75zm-18.5-22.5c-.689 0-1.25.561-1.25 1.25v18.5c0 .689.561 1.25 1.25 1.25h18.5c.689 0 1.25-.561 1.25-1.25v-18.5c0-.689-.561-1.25-1.25-1.25z"
          />
          <path
            fill="#333"
            d="m12 24c-.414 0-.75-.336-.75-.75v-22.5c0-.414.336-.75.75-.75s.75.336.75.75v22.5c0 .414-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m23.25 12.75h-22.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h22.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m6 9c-.414 0-.75-.336-.75-.75v-3.5c0-.414.336-.75.75-.75s.75.336.75.75v3.5c0 .414-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m7.75 7.25h-3.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h3.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m4.75 20c-.192 0-.384-.073-.53-.22-.293-.293-.293-.768 0-1.061l2.5-2.5c.293-.293.768-.293 1.061 0s.293.768 0 1.061l-2.5 2.5c-.147.147-.339.22-.531.22z"
          />
          <path
            fill="#333"
            d="m7.25 20c-.192 0-.384-.073-.53-.22l-2.5-2.5c-.293-.293-.293-.768 0-1.061s.768-.293 1.061 0l2.5 2.5c.293.293.293.768 0 1.061-.147.147-.339.22-.531.22z"
          />
          <path
            fill="#333"
            d="m20.25 7h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m20.25 20h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
          <path
            fill="#333"
            d="m20.25 17h-4.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h4.5c.414 0 .75.336.75.75s-.336.75-.75.75z"
          />
        </svg>
      );
    }
  }
  render() {
    //for globals
    let studentGlobals = "";
    if (JSON.parse(localStorage.getItem("studentglobals")) != "") {
      studentGlobals = JSON.parse(localStorage.getItem("studentglobals"));
    } else {
      this.props.history.push("/student/login");
    }

    //for globalsubjects
    let globalsubjects = "";
    if (JSON.parse(localStorage.getItem("globalsubjects")) != "") {
      globalsubjects = JSON.parse(localStorage.getItem("globalsubjects"));
    } else {
      this.props.history.push("/student/login");
    }

    const getPreviousPaperAnalysis = this.props.getPreviousPaperAnalysis;
    const loading1 = getPreviousPaperAnalysis.loading;
    const error1 = getPreviousPaperAnalysis.error;

    if (loading1) {
      return (
        <div className="mt-4 questiontype-wise">
          <div className="d-flex justify-content-center">
            <div class="spinner-border text-primary text-center"></div>
          </div>
        </div>
      );
    } else if (error1 !== undefined || !getPreviousPaperAnalysis || !getPreviousPaperAnalysis.getPreviousPaperAnalysis) {
      return (
        <div className="mt-4 questiontype-wise">
          <div className="d-flex justify-content-center">
            <p className="text-danger mb-0">Analysis data is currently unavailable. Please try again later.</p>
          </div>
        </div>
      );
    } else {
      const getPreviousPaperAnalysisData1 =
        getPreviousPaperAnalysis.getPreviousPaperAnalysis.subjects_weightage.map(
          (smap) => {
            if (smap != undefined) {
              const singleSubject = globalsubjects.find((a) => a.id == smap.id);
              const complexityArr = smap.complexity.map((commap) => {
                if (commap != undefined) {
                  const singlecomplexityType = studentGlobals.complexity.find(
                    (a) => a.id == commap.id,
                  );
                  if (singlecomplexityType != undefined) {
                    return {
                      ...commap,
                      complexity: singlecomplexityType.complexity,
                    };
                  }
                }
              });
              if (singleSubject != undefined) {
                return {
                  ...smap,
                  subject: singleSubject.subject,
                  complexity: complexityArr,
                };
              }
            }
          },
        );

      const complexityWeightageData =
        getPreviousPaperAnalysis.getPreviousPaperAnalysis.complexityWeightage.map(
          (cmap) => {
            if (cmap != undefined) {
              const singlecomplexityType = studentGlobals.complexity.find(
                (a) => a.id == cmap.id,
              );
              if (singlecomplexityType != undefined) {
                return { ...cmap, complexity: singlecomplexityType.complexity };
              }
            }
          },
        );
      const getPreviousPaperAnalysisData = {
        ...getPreviousPaperAnalysis.getPreviousPaperAnalysis,
        subjects_weightage: getPreviousPaperAnalysisData1,
        complexityWeightage: complexityWeightageData,
      };
      if (getPreviousPaperAnalysisData.complexityWeightage.length > 0) {
        return (
          <React.Fragment>
            <Row>
              <Col>
                <h6>Complexity Wise</h6>
              </Col>
            </Row>
            <Row>
              <Col
                xl={12}
                lg={12}
                md={12}
                sm={12}
                className="previous_complexity_wise"
              >
                <CardLessDataTable
                  articlecolumns={this.subjectQuestionTheoryColumns(
                    getPreviousPaperAnalysisData.complexityWeightage,
                    "complexity",
                  )}
                  articledata={this.subjectQuestionTheoryData(
                    getPreviousPaperAnalysisData.complexityWeightage,
                    "complexity",
                    "0",
                  )}
                  defaultSorted={this.defaultSorted}
                />
              </Col>
            </Row>
            <Row className="mt-4 subject-wise">
              <Col xl={12} lg={12} md={12} sm={12}>
                <h6>Subject Wise</h6>
              </Col>
              {getPreviousPaperAnalysisData.subjects_weightage.map((smap) => {
                return (
                  <Col xl={12} lg={12} md={12} sm={12}>
                    <Card className={this.subjectClassFun(smap.subject)}>
                      <Card.Header className="bg-white mb-0 shadow-sm">
                        <Card.Title className="mb-0 h6 px-2">
                          <div className="d-flex">
                            {this.imageFunction(smap.subject)}
                            <span className="ml-2 title">{smap.subject}</span>
                          </div>
                        </Card.Title>
                      </Card.Header>
                      <Card.Body
                        //style={{ height: 200 }}
                        //className="p-0 lock"
                        className="p-0"
                      >
                        <CardLessDataTable
                          articlecolumns={this.subjectQuestionTheoryColumns(
                            smap.complexity,
                            "complexity",
                          )}
                          articledata={this.subjectQuestionTheoryData(
                            smap.complexity,
                            "complexity",
                            smap.id,
                          )}
                          defaultSorted={this.defaultSorted}
                        />
                        {/* <div className="lock-content d-block">
                                            <h5>Lock</h5>
                                        </div> */}
                      </Card.Body>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </React.Fragment>
        );
      }
    }
  }
}
export default withRouter(
  compose(
    graphql(FETCH_PREVIOUSDATA, {
      options: (props) => ({
        variables: {
          examType: parseInt(props.stateData.pexamtype),
          subjects: props.stateData.psubject,
          //years:"2019",
          years: props.stateData.pyeartype.toString(),
          id: parseInt(Cookies.get("id")),
          student_user_exam_id: parseInt(Cookies.get("examid")),
        },
        fetchPolicy: "no-cache",
      }),
      name: "getPreviousPaperAnalysis",
    }),
  )(ComplexityInner),
);
